const config = {
    API: {
      LAMBDA_URL:  process.env.REACT_APP_LAMBDA_URL || '',
    },
    MODELS: {
      DEFAULT: process.env.REACT_APP_LLM || ''
  }
};
  
  export default config;